export const isFromScenes: boolean = /FBAN\/Scenes for iOS;/.test(navigator.userAgent);
